import { TFunction } from "i18next";

import { EntityConfigurationType } from "@/api/rest/services/configurationService";

const configurationTypeLabels: Partial<Record<EntityConfigurationType, { key: string; defaultValue: string }>> = {
  [EntityConfigurationType.WELCOME_EMAIL]: {
    key: "building.welcomeEmail",
    defaultValue: "Welcome Email",
  },
  [EntityConfigurationType.FRONTEND_FEATURE_FLAGS]: {
    key: "building.frontendFeatureFlags",
    defaultValue: "Frontend Feature Flags",
  },
  [EntityConfigurationType.LOOKER_REPORT_LINK]: {
    key: "building.lookerReportLink",
    defaultValue: "Looker Report Link",
  },
};

const formatEnumFallback = (value: string) =>
  value
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const getConfigurationTypeLabel = (t: TFunction, type: EntityConfigurationType) => {
  const mapping = configurationTypeLabels[type];
  if (mapping) {
    return t(mapping.key, mapping.defaultValue);
  }

  return formatEnumFallback(type);
};
